import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
// import logo from "../../assets/logo.svg";
import logo from "../../assets/logo_new.svg";
import { designTokens } from "../../theme/designTokens";

const { colors, fonts, fontSizes, spacing, navLinks } = designTokens;

const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const location = useLocation();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => setAnchorElNav(null);

  const isActive = (path: string) => {
    if (path.startsWith("http") || path.includes("#")) return false;
    return location.pathname === path;
  };

  const navSx = (active: boolean) => ({
    color: active ? colors.primary : colors.textPrimary,
    fontWeight: active ? fonts.weights.semibold : fonts.weights.regular,
    fontSize: fontSizes.navLink,
    letterSpacing: 1,
    textTransform: "none" as const,
    borderBottom: active ? `2px solid ${colors.primary}` : "none",
    borderRadius: 0,
    mx: 0.5,
    my: 1.5,
    minWidth: "auto",
    px: 1,
    "&:hover": { color: colors.primary, backgroundColor: "transparent" },
  });

  const renderLink = (item: (typeof navLinks)[number], onClick?: () => void) => {
    const active = isActive(item.path);

    if (item.external) {
      return (
        <Button
          key={item.name}
          component="a"
          href={item.path}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClick}
          sx={navSx(false)}
        >
          {item.name}
        </Button>
      );
    }

    if (item.path.includes("#")) {
      return (
        <Button
          key={item.name}
          component="a"
          href={item.path}
          onClick={onClick}
          sx={navSx(false)}
        >
          {item.name}
        </Button>
      );
    }

    return (
      <Button
        key={item.name}
        component={Link}
        to={item.path}
        onClick={onClick}
        sx={navSx(active)}
      >
        {item.name}
      </Button>
    );
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: colors.white,
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      }}
    >
      <Container maxWidth={spacing.containerMax}>
        <Toolbar disableGutters sx={{ minHeight: spacing.headerHeight }}>
          <IconButton component={Link} to="/" sx={{ display: { xs: "none", md: "flex" }, p: 0, mr: 2 }}>
            <Box component="img" src={logo} alt={designTokens.company.name} sx={{ height: 50, width: "auto" }} />
          </IconButton>

          <Box sx={{ display: { xs: "flex", md: "none" }, flexGrow: 1, alignItems: "center" }}>
            <IconButton size="large" onClick={handleOpenNavMenu} sx={{ color: colors.textPrimary }}>
              <MenuIcon />
            </IconButton>
            <IconButton component={Link} to="/" sx={{ ml: "auto" }}>
              <Box component="img" src={logo} alt={designTokens.company.name} sx={{ height: 30 }} />
            </IconButton>
            <Menu anchorEl={anchorElNav} open={Boolean(anchorElNav)} onClose={handleCloseNavMenu}>
              {navLinks.map((item) => (
                <MenuItem key={item.name} onClick={handleCloseNavMenu}>
                  {item.external ? (
                    <Typography component="a" href={item.path} target="_blank" rel="noopener noreferrer" sx={{ color: colors.textPrimary, textDecoration: "none" }}>
                      {item.name}
                    </Typography>
                  ) : item.path.includes("#") ? (
                    <Typography component="a" href={item.path} sx={{ color: colors.textPrimary, textDecoration: "none" }}>
                      {item.name}
                    </Typography>
                  ) : (
                    <Typography component={Link} to={item.path} sx={{ color: colors.textPrimary, textDecoration: "none" }}>
                      {item.name}
                    </Typography>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap" }}>
            {navLinks.map((item) => renderLink(item, handleCloseNavMenu))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
